import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';
import assetType from '../assetTypes';
import editAssetTypeDialog from '../assetTypes/dialog.editAssetTypeDialog';

export class dialogService {
  getOptions($event, {
    assetTypes,
  }) {
    return {
      controller,
      controllerAs: 'assetAdminSettingsDialogVM',
      locals: {
        assetTypes,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.assetAdministration.assetAdminSettingsDialog', [
  ssDialogService,
  loaderService,
  assetDataService,
  alerts,
  assetType,
  editAssetTypeDialog,
])
  .service('assetAdminSettingsDialog', dialogService)
  .name;

console.log('app.components.admin.assetAdministration.assetAdminSettingsDialog created');
